export const QUALITY_OF_SERVICE_URL = 'https://my.cian.ru/quality-of-service/';
export const MY_CIAN_URL = 'https://my.cian.ru/';
export const EMPLOYEES_URL = 'https://my.cian.ru/employees';
export const AUTH_URL = 'https://www.cian.ru/authenticate/';
export const SUPERHOST_PAGE_URL = 'https://www.cian.ru/promotions/superhost';
export const MAX_COMMUNITY_URL = 'https://max.ru/join/YcjryI9FliW7FchOdawWB8abPLZpY8z4qzbU3Ovzoh0';
export const TELEGRAM_CHANNEL_URL = 'https://t.me/+Oyul_jBMV7dhODEy';
export const LEGAL_ENTITY_OFFER_URL = 'https://www.cian.ru/legal-documents/agentskij_dogovor_posutochno_yulip_0';
export const INDIVIDUAL_OFFER_URL = 'https://www.cian.ru/legal-documents/agentskij_dogovor_posutochno_flsmz_0';
export const BOOKING_EMAIL = 'mailto:booking@cian.ru';
